export const Links = {
    BASE_URL_WITHOUT_TENANT: import.meta.env.VITE_API_BASE_URL //||
    //(import.meta.env.DEV
    //  ? '' // Development'ta proxy kullan, boş string
    //: 'https://inttech-btbph6gzdvb9gvas.northeurope-01.azurewebsites.net'
    //),
    //DEPLOY    ),
    // Artık geri dönüş mekanizmasını kaldırıyoruz. Her zaman ENV değişkenini kullan.
    //BASE_URL_WITHOUT_TENANT: import.meta.env.VITE_API_BASE_URL
};

export default Links;
